



import React, { useState } from 'react';
import { Chip } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';

const UNPAID_STATUSES = ['pending', 'pay to agent', 'failed'];

function isOrderUnpaid(order) {
  const paymentStatus = order?.payment?.status;
  if (UNPAID_STATUSES.includes(paymentStatus)) return true;

  // Also check the most recent transaction_history entry —
  // payment.status can lag behind the actual last transaction outcome
  const txHistory = order?.payment?.transaction_history;
  if (Array.isArray(txHistory) && txHistory.length > 0) {
    const lastTx = txHistory[txHistory.length - 1];
    if (UNPAID_STATUSES.includes(lastTx?.status)) return true;
  }

  return false;
}

function PaymentPendingChip({ order, apiFetch, notify }) {
  const [sending, setSending] = useState(false);

  const isPending = isOrderUnpaid(order);
  if (!isPending) return null;

  const phone = order?.user_phone || order?.delivery_address?.phone;

  const handleSend = async (e) => {
    e.stopPropagation();
    if (!phone) {
      notify?.('No phone number on this order', 'error');
      return;
    }
    setSending(true);
    try {
      const res = await apiFetch(
        `${process.env.REACT_APP_WHATSAPP_REMINDER_API_URL}/send-payment-reminder`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            order_id: order.order_id,
            order_type: order.service_type === 'diagnostic' ? 'diagnostic' : 'medicine',
            phone,
            amount: order.total_amount,
          }),
        }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to send reminder');
      notify?.('Payment reminder sent on WhatsApp', 'success');
    } catch (err) {
      notify?.(err.message, 'error');
    } finally {
      setSending(false);
    }
  };

  return (
    <Chip
      size="small"
      icon={<WhatsApp sx={{ fontSize: 14 }} />}
      label={sending ? 'Sending…' : 'Unpaid'}
      onClick={handleSend}
      clickable
      disabled={sending}
      sx={{
        bgcolor: '#E9D5FF',
        color: '#000',
        fontWeight: 700,
        '&:hover': { bgcolor: '#F3E8FF' },
      }}
    />
  );
}

export default PaymentPendingChip;